// The Group Chat with Catchy guide (62_Gcc.jsx · ModuleHelp, Max 01/11).
const en = {
  roomsT: 'Your rooms',
  roomsB: 'The rooms you belong to, with the last message and how many people are in each. A number badge means unread messages.',
  newT: 'Start a room',
  newB: 'Create a room and pick the colleagues, or whole teams and entities, to invite. They get an email invitation.',
  pickT: 'Open a room',
  pickB: 'Pick a room on the left to read and write in it. The next steps appear once a room is open.',
  membersT: 'Who is in the room',
  membersB: 'The faces open the member list. Use Add people in the top bar to invite more colleagues.',
  catchyT: 'Catchy on or off',
  catchyB: 'When on, Catchy follows the chat, answers when you write @Catchy and posts what may help in its side window. Switch it off for a room where it should stay quiet.',
  trT: 'Translate',
  trB: 'Shows messages in your portal language from the moment you switch it on. Off, you read every message as it was written.',
  threadT: 'The conversation',
  threadB: 'Messages from you, your colleagues and Catchy. You can reply, edit your own message, react with an emoji and open attached files.',
  composeT: 'Write a message',
  composeB: 'Enter sends, Shift+Enter starts a new line. The @Catchy button asks Catchy directly; the paperclip and the smiley add files and emoji.',
};
const ko = {
  roomsT: '내 대화방',
  roomsB: '참여 중인 방과 마지막 메시지, 인원 수가 표시됩니다. 숫자 배지는 읽지 않은 메시지입니다.',
  newT: '방 만들기',
  newB: '방을 만들고 초대할 동료, 또는 팀·Entity 전체를 고르세요. 초대 메일이 발송됩니다.',
  pickT: '방 열기',
  pickB: '왼쪽에서 방을 고르면 대화를 읽고 쓸 수 있습니다. 방을 열면 다음 단계가 이어서 나옵니다.',
  membersT: '방 참여자',
  membersB: '얼굴 아이콘을 누르면 참여자 목록이 열립니다. 위쪽 사람 추가로 동료를 더 초대할 수 있습니다.',
  catchyT: 'Catchy 켜기·끄기',
  catchyB: '켜 두면 Catchy가 대화를 따라가고, @Catchy라고 쓰면 답하며, 도움이 될 내용을 옆 창에 올립니다. 조용해야 하는 방에서는 끄세요.',
  trT: '번역',
  trB: '켠 시점부터 메시지를 내 포털 언어로 보여 줍니다. 끄면 모든 메시지가 쓰인 그대로 보입니다.',
  threadT: '대화 내용',
  threadB: '나, 동료, Catchy의 메시지가 표시됩니다. 답장, 내 메시지 수정, 이모지 반응, 첨부 파일 열기가 가능합니다.',
  composeT: '메시지 쓰기',
  composeB: 'Enter로 전송하고 Shift+Enter로 줄을 바꿉니다. @Catchy 버튼은 Catchy에게 바로 묻고, 클립과 이모티콘 버튼은 파일과 이모지를 추가합니다.',
};
const vi = {
  roomsT: 'Các phòng của bạn',
  roomsB: 'Những phòng bạn tham gia, kèm tin nhắn cuối và số người trong từng phòng. Số trên huy hiệu là tin chưa đọc.',
  newT: 'Tạo phòng',
  newB: 'Tạo phòng và chọn đồng nghiệp, hoặc cả team và entity, để mời. Họ sẽ nhận email mời.',
  pickT: 'Mở một phòng',
  pickB: 'Chọn một phòng ở bên trái để đọc và viết. Các bước tiếp theo sẽ hiện khi bạn đã mở một phòng.',
  membersT: 'Ai đang trong phòng',
  membersB: 'Bấm vào các khuôn mặt để mở danh sách thành viên. Dùng Thêm người ở thanh trên để mời thêm đồng nghiệp.',
  catchyT: 'Bật hoặc tắt Catchy',
  catchyB: 'Khi bật, Catchy theo dõi cuộc trò chuyện, trả lời khi bạn viết @Catchy và đưa gợi ý hữu ích vào cửa sổ bên cạnh. Tắt nếu phòng đó cần yên tĩnh.',
  trT: 'Dịch',
  trB: 'Hiển thị tin nhắn bằng ngôn ngữ portal của bạn kể từ lúc bật. Tắt thì bạn đọc mọi tin đúng như người viết.',
  threadT: 'Cuộc trò chuyện',
  threadB: 'Tin nhắn của bạn, đồng nghiệp và Catchy. Bạn có thể trả lời, sửa tin của mình, thả emoji và mở tệp đính kèm.',
  composeT: 'Viết tin nhắn',
  composeB: 'Enter để gửi, Shift+Enter để xuống dòng. Nút @Catchy hỏi thẳng Catchy; kẹp giấy và mặt cười để thêm tệp và emoji.',
};
const zh = {
  roomsT: '你的聊天室',
  roomsB: '你所在的聊天室，显示最后一条消息和人数。数字角标表示未读消息。',
  newT: '新建聊天室',
  newB: '创建聊天室并选择要邀请的同事，或整个团队和 entity。他们会收到邀请邮件。',
  pickT: '打开聊天室',
  pickB: '在左侧选择一个聊天室即可阅读和发言。打开聊天室后会继续后面的步骤。',
  membersT: '谁在聊天室里',
  membersB: '点击头像可打开成员列表。用顶部的添加成员可邀请更多同事。',
  catchyT: '开启或关闭 Catchy',
  catchyB: '开启后，Catchy 会跟进聊天，你写 @Catchy 时它会回答，并把可能有用的内容放在侧边窗口。需要保持安静的聊天室可以关闭它。',
  trT: '翻译',
  trB: '从开启那一刻起，用你的门户语言显示消息。关闭后，你看到的每条消息都是原文。',
  threadT: '对话内容',
  threadB: '你、同事和 Catchy 的消息。可以回复、编辑自己的消息、用表情回应，并打开附件。',
  composeT: '写消息',
  composeB: '按 Enter 发送，Shift+Enter 换行。@Catchy 按钮直接向 Catchy 提问；回形针和笑脸按钮用来添加文件和表情。',
};
const dictionary = { ns: 'tourGcc', en, ko, vi, zh };
export default dictionary;
